import { render, staticRenderFns } from "./Shops.vue?vue&type=template&id=404466bf&"
import script from "./Shops.vue?vue&type=script&lang=ts&"
export * from "./Shops.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports